'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColourHex = exports.getColourName = exports.elementsResourcesSelector = exports.getElement = exports.getElements = exports.getElementId = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Util


var _reselect = require('reselect');

var _elementHelper = require('../../common/elements/elementHelper');

var _elementFilterUtil = require('./elementFilter/elementFilterUtil');

var _resourceSelector = require('../utils/services/http/resources/resourceSelector');

var _resourceConstants = require('../utils/services/http/resources/resourceConstants');

var _colorHelper = require('../../common/colors/colorHelper');

var _currentlyEditingSelector = require('./selection/currentlyEditingSelector');

var _selectedElementsSelector = require('./selection/selectedElementsSelector');

var _dragModifierKeysSelector = require('../utils/dnd/modifierKeys/dragModifierKeysSelector');

var _recompose = require('recompose');

var _milanoteReselect = require('../utils/milanoteReselect/milanoteReselect');

var getElementId = exports.getElementId = function getElementId(state, ownProps) {
    return ownProps.elementId || ownProps.element && ownProps.element.get('id');
};
var getElements = exports.getElements = function getElements(state) {
    return state.get('elements');
};
var getElement = exports.getElement = function getElement(state, ownProps) {
    return ownProps.element || getElements(state).get(ownProps.elementId);
};
var elementsResourcesSelector = exports.elementsResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)(_resourceConstants.RESOURCE_TYPES.elements);

// Is editing selector helper methods
var getIsEditingStateSlice = function getIsEditingStateSlice(state, ownProps) {
    return {
        elementId: getElementId(state, ownProps),
        element: getElement(state, ownProps),
        elements: getElements(state, ownProps),
        currentlyEditingId: (0, _currentlyEditingSelector.getCurrentlyEditingId)(state, ownProps),
        currentEditorKey: (0, _currentlyEditingSelector.getCurrentlyEditingEditorKey)(state, ownProps)
    };
};
var isEditingSelectorEqualityChecker = function isEditingSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
    if (prevStateSlice.currentlyEditingId === nextStateSlice.currentlyEditingId) {
        return prevStateSlice.currentEditorKey === nextStateSlice.currentEditorKey;
    }
    return (0, _recompose.shallowEqual)(prevStateSlice, nextStateSlice);
};
var createCustomIsEditingSelector = (0, _milanoteReselect.createCustomEqualShallowSelector)(isEditingSelectorEqualityChecker);

var isEditingSelector = function isEditingSelector() {
    return createCustomIsEditingSelector(getIsEditingStateSlice, function (_ref) {
        var elementId = _ref.elementId,
            element = _ref.element,
            elements = _ref.elements,
            currentlyEditingId = _ref.currentlyEditingId,
            currentEditorKey = _ref.currentEditorKey;

        var isEditing = false;
        var isEditingChild = false;
        var _currentEditorKey = null;

        if (currentlyEditingId) {
            isEditing = currentlyEditingId === elementId;
            _currentEditorKey = isEditing ? currentEditorKey : null;

            // Only performing this check if needed (to help improve performance)
            if (!isEditing && (0, _elementHelper.isContainer)(element)) {
                isEditingChild = (0, _elementHelper.getChildren)(elements, elementId).reduce(function (found, el) {
                    return found || el.get('id') === currentlyEditingId;
                }, false);
            }
        }

        return {
            isEditing: isEditing,
            isEditingChild: isEditingChild,
            currentEditorKey: _currentEditorKey
        };
    });
};

var isSelectedSelector = function isSelectedSelector() {
    return (0, _reselect.createSelector)(getElementId, _selectedElementsSelector.getSelectedElementIds, function (elementId, selectedElementIds) {
        return selectedElementIds.includes(elementId);
    });
};

var isSingleSelectedSelector = function isSingleSelectedSelector() {
    return (0, _reselect.createSelector)(getElementId, _selectedElementsSelector.getSelectedElementIds, function (elementId, selectedElementIds) {
        return selectedElementIds.size === 1 && selectedElementIds.includes(elementId);
    });
};

var remoteActivitySelector = function remoteActivitySelector() {
    return (0, _milanoteReselect.createShallowSelector)(getElementId, function (state) {
        return state.getIn(['remoteActivity', 'selectedElements']);
    }, function (elementId, remoteElementActivity) {
        var remoteSelectionData = remoteElementActivity.get(elementId);
        var isRemotelySelected = remoteSelectionData && !!remoteSelectionData.get('userId');

        return {
            remoteSelectionData: remoteSelectionData,
            isRemotelySelected: isRemotelySelected
        };
    });
};

var isLockedSelector = function isLockedSelector() {
    return function (state, ownProps) {
        return (0, _elementHelper.isElementLocked)(getElement(state, ownProps));
    };
};

var filterSelector = function filterSelector() {
    return (0, _reselect.createSelector)(getElement, function (state, ownProps) {
        return ownProps.elementFilter;
    }, function (element, elementFilter) {
        if (!elementFilter) return null;

        if ((0, _elementFilterUtil.filterElement)(element, elementFilter)) return 'filter-pass';

        return 'filter-fail';
    });
};

var getColourName = exports.getColourName = function getColourName(state, ownProps) {
    return getElement(state, ownProps).getIn(['content', 'color']);
};

var getColourHex = exports.getColourHex = (0, _reselect.createSelector)(getColourName, _colorHelper.getColorHexValue);

exports.default = function () {
    return (0, _reselect.createSelector)(isSelectedSelector(), isSingleSelectedSelector(), remoteActivitySelector(), isEditingSelector(), isLockedSelector(), filterSelector(), _dragModifierKeysSelector.getDragModifierKeys, function (isSelected, isSingleSelected, remoteActivity, isEditing, isLocked, filter, dragModifierKeys) {
        return _extends({}, isEditing, remoteActivity, {
            isSingleSelected: isSingleSelected,
            isSelected: isSelected,
            isLocked: isLocked,
            filter: filter,
            dragModifierKeys: dragModifierKeys
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementSelector.js
// module id = 41
// module chunks = 0